module.exports = __webpack_public_path__ + "static/img/news_banner.e2f1d2ad.png";